import CollapseCard from './src/main.js'

CollapseCard.install = function (Vue) {
  Vue.component(CollapseCard.name, CollapseCard)
}

export default CollapseCard
